import React, { useCallback } from 'react';
import CompanyHistoryComponent from './CompanyHistory.component';
import { CompanyHistoryEditorProps } from './CompanyHistory.types';
import { adaptCompanyHistoryEditorProps } from './CompanyHistory.adapter';
import { v4 as uuidv4 } from 'uuid';

/**
 * 회사 연혁 에디터 컴포넌트
 */
const CompanyHistoryEditor: React.FC<any> = (props) => {
  // 어댑터를 통해 props 변환
  const adaptedProps = adaptCompanyHistoryEditorProps(props);
  const { isSelected, isPreview, updateComponent, ...componentProps } = adaptedProps;

  // 선택 표시자와 핸들 스타일
  const selectionIndicatorStyle: React.CSSProperties = {
    position: 'absolute',
    top: -2,
    left: -2,
    right: -2,
    bottom: -2,
    border: '2px solid #3498db',
    borderRadius: 4,
    pointerEvents: 'none',
    zIndex: 1
  };

  const resizeHandleStyle: React.CSSProperties = {
    position: 'absolute',
    width: 8,
    height: 8,
    backgroundColor: '#3498db',
    border: '1px solid white',
    borderRadius: '50%',
    zIndex: 10
  };

  // 히스토리 항목 추가 함수
  const handleAddHistoryItem = useCallback(() => {
    const historyItems = componentProps.historyItems || [];
    const newHistoryItem = {
      id: uuidv4(),
      year: new Date().getFullYear().toString(),
      title: '새 이벤트 제목',
      description: '이벤트에 대한 설명을 입력하세요.',
      image: ''
    };
    
    updateComponent({
      historyItems: [...historyItems, newHistoryItem]
    });
  }, [componentProps.historyItems, updateComponent]);

  // 타임라인 스타일 변경 함수
  const toggleTimelineStyle = useCallback(() => {
    const currentStyle = componentProps.timelineStyle || 'vertical';
    const newStyle = currentStyle === 'vertical' ? 'horizontal' : 'vertical';
    
    updateComponent({
      timelineStyle: newStyle
    });
  }, [componentProps.timelineStyle, updateComponent]);

  // 애니메이션 토글 함수
  const toggleAnimation = useCallback(() => {
    const currentAnimation = componentProps.animation !== undefined ? 
      componentProps.animation : true;
    
    updateComponent({
      animation: !currentAnimation
    });
  }, [componentProps.animation, updateComponent]);

  // 미리보기 모드이거나 선택되지 않았으면 기본 컴포넌트만 렌더링
  if (isPreview || !isSelected) {
    return <CompanyHistoryComponent {...componentProps} />;
  }

  // 에디터 모드에서 선택된 상태 - 리사이즈/이동 핸들 표시
  return (
    <div style={{ position: 'relative', width: '100%', height: '100%' }}>
      {/* 실제 컴포넌트 */}
      <CompanyHistoryComponent {...componentProps} />

      {/* 선택 표시 */}
      <div style={selectionIndicatorStyle}></div>

      {/* 리사이즈 핸들 */}
      <div style={{ ...resizeHandleStyle, top: -4, left: -4, cursor: 'nw-resize' }} data-handle="nw"></div>
      <div style={{ ...resizeHandleStyle, top: -4, right: -4, cursor: 'ne-resize' }} data-handle="ne"></div>
      <div style={{ ...resizeHandleStyle, bottom: -4, left: -4, cursor: 'sw-resize' }} data-handle="sw"></div>
      <div style={{ ...resizeHandleStyle, bottom: -4, right: -4, cursor: 'se-resize' }} data-handle="se"></div>

      {/* 이동 핸들 */}
      <div style={{
        position: 'absolute',
        top: -16,
        left: '50%',
        transform: 'translateX(-50%)',
        width: 20,
        height: 10,
        backgroundColor: '#3498db',
        borderRadius: '3px 3px 0 0',
        cursor: 'move'
      }}></div>
  
      
    </div>
  );
};

export default CompanyHistoryEditor; 